export function Icon({ name }) {
    return (
        <svg className="feather">
            <use href={`/assets/feather-sprite.svg#${name}`} />
        </svg>
    )
}
